import { isEqual } from 'lodash';
import axios from 'axios';
import { clearState } from '../../middleware/clearStorageMiddleware';

export const setDeployId = (deployId) => ({
  type: 'SET_DEPLOY_ID',
  deployId,
});

export const setBuildInfo = (buildInfo) => ({
  type: 'SET_BUILD_INFO',
  buildInfo,
});

export const checkDeploy = (prevDeployId) => (dispatch) => {
  const { origin } = window.location;

  axios.get(`${origin}/build.json?timestamp=${new Date().getTime()}`)
    .then((resp) => {
      const deployId = `${resp.data.branchCommit}${resp.data.buildDate}`;

      dispatch(setDeployId(deployId));

      // Save full build information
      dispatch(setBuildInfo(resp.data));

      if (prevDeployId && !isEqual(deployId, prevDeployId)) {
        dispatch(clearState());
        window.location.reload(true);
      }
    })
    .catch((err) => console.log(`Could not retrieve deploy version. ${err}`));
};
